import * as React from "react";
const useIsDesktop = (threshold = 740) => {
  var _a, _b, _c;
  const initialMatch = (_c = (_b = (_a = global.window) == null ? void 0 : _a.matchMedia) == null ? void 0 : _b.call(_a, `(min-width: ${threshold}px)`).matches) != null ? _c : false;
  const [match, setMatch] = React.useState({
    matches: initialMatch
  });
  React.useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${threshold}px)`);
    setMatch({ matches: mql.matches });
    mql.addEventListener && mql.addEventListener("change", setMatch);
    mql.addListener && mql.addListener(setMatch);
    return () => {
      mql.removeEventListener && mql.removeEventListener("change", setMatch);
      mql.removeListener && mql.removeListener(setMatch);
    };
  }, [threshold]);
  return match.matches;
};
export {
  useIsDesktop
};
